module.exports = __webpack_public_path__ + "static/media/trash-icon.c60b7ca3.svg";